(function () {
  function toggleItem(item) {
    var btn = item.querySelector('[data-faq-toggle]');
    var answer = item.querySelector('[data-faq-answer]');
    if (!btn || !answer) return;

    var open = btn.getAttribute('aria-expanded') !== 'true';
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    answer.style.maxHeight = open ? answer.scrollHeight + 'px' : '';
  }

  function init(list) {
    list.querySelectorAll('[data-faq-item]').forEach(function (item) {
      var btn = item.querySelector('[data-faq-toggle]');
      if (!btn) return;
      btn.addEventListener('click', function () { toggleItem(item); });
    });
  }

  function initAll() {
    document.querySelectorAll('.cat-faq__list').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.cat-faq__list').forEach(init);
  });
})();
